// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.success-msg[data-v-793fd7ba] {\n  color: #00747b;\n  font-size: 20px;\n  text-align: center;\n  padding-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
